//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Action,
  ActionText,
  Illustration,
  Typography,
} from '@backmarket/design-system'

import { MARKETPLACES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import { COOKIES_TRACKING_NAME } from '../../constants'

import translations from './CookiesModal.translations'

export default {
  components: {
    Action,
    ActionText,
    Typography,
    Illustration,
    FormattedMessage,
  },

  props: {
    marketplace: {
      type: String,
      required: true,
    },
    zone: {
      type: String,
      default: '',
    },
  },

  computed: {
    translations: () => translations,
    ROUTES: () => ROUTES,
    displayRefuseAllButton() {
      return this.marketplace !== MARKETPLACES.NA
    },
    cookieImage() {
      return this.$static('/img/gdpr/cookie.png')
    },
  },

  methods: {
    handleClickAccept() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.ACCEPT })
      this.$emit('accept')
    },
    handleClickRefuse() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.REFUSE })
      this.$emit('refuse')
    },
    handleClickParams() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.SETTINGS })
      this.$emit('params')
    },
    handleClickTerms() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.INFO })
    },
  },
}
